'use strict';

export enum PopoverLocation {
  Below = 'Below',
  Left = 'Left',
  Right = 'Right',
  Above = 'Above',
}
